
import { EVENT_SOURCE } from '~~/constants/googleTagManager';

import type { EventSourceLocation } from '~~/types/integrations/tagManager/TagManagerIntegration';

type GetAddToCartButtonLocationParams = {
  isMainProduct?: boolean;
};

type UseRouteOfAddToCartReturn = {
  getAddToCartButtonLocation: (params: GetAddToCartButtonLocationParams) => EventSourceLocation;
};

export const useRouteOfAddToCart = (): UseRouteOfAddToCartReturn => {

  const { isOnProductPage, isOnHomePage, isOnSearchPage } = useIsPage();
  const { isOnCategory } = useIsOnCategory();

  const getAddToCartButtonLocation = ({
    isMainProduct,
  }: GetAddToCartButtonLocationParams): EventSourceLocation => {

    switch (true) {

      case isMainProduct:
        return EVENT_SOURCE.PDP;
      case isOnSearchPage.value:
        return EVENT_SOURCE.SEARCH_LISTING;
      case isOnHomePage.value:
        return EVENT_SOURCE.HOMEPAGE_TOP_SELLERS;
      case isOnProductPage.value:
        return EVENT_SOURCE.PDP_SIMILAR_PRODUCTS;
      case isOnCategory():
        return EVENT_SOURCE.CATEGORY_LISTING;
      default:
        return undefined;
    
    }
  
  };

  return {
    getAddToCartButtonLocation,
  };

};
